<template>
    <div class="list-base" :class="mainClass">
        <Loading v-if="loading" :background="false"/>
        <slot name="list-start"></slot>
        <slot name="list-empty" v-if="isEmpty && !loading">
        </slot>
        <template
            v-for="(item, index) in sortedItems"
            >
            <slot
                name="list-item"
                :item="item"
                :index="index"
                :options="options"
                ></slot>
        </template>
        <slot name="list-end"></slot>
    </div>
</template>

<script>
import {arrayUtils} from '@/utils/ArrayUtils'
import Loading from './../loading/Loading.vue'

export default {
    components: {
        Loading
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        max: {
            type: Number,
            default: -1
        },
        filters: {
            type: Array,
            default: () => []
        },
        sorts: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        options: {
            type: Object,
            default () { return {} }
        }
    },
    computed: {
        sortedItems () {
            if (this.items.length <= 0) return this.items
            let a = arrayUtils.filterMany(this.items, this.filters)
            a = arrayUtils.sortMany(a, this.sorts)
            if (this.max < 0) return a
            return a.slice(0, this.max)
        },
        isEmpty () {
            return this.sortedItems.length <= 0
        },
        mainClass () {
            return this.isEmpty ? 'empty' : ''
        }
    },
    methods: {
    }
}
</script>

<style lang="stylus">
@import "~themes/variables";

.list-base
    position relative
    display flex
    justify-content space-between
    flex 1 1 auto

    // &::after
    //     content ''
    //     flex auto

    & > .cv-content-loading
        background-color transparent

    &.empty
        justify-content space-between

    .list-base-empty
        align-self center
        margin 24px

        .cv-icon
            margin-right 6px

.list-base-empty-enter
    z-index 1
    transform scale(0.95, 0.95) translateY(-100px)
    opacity 0

.list-base-empty-enter-active
.list-base-empty-leave-active
    transition transform 0.5s, opacity 0.5s cubic-bezier(0.19, 1, 0.22, 1)

.list-base-empty-leave
    z-index -1
    transition-delay 0s

.list-base-empty-leave-to
    transform translateY(50px)
    opacity 0
</style>



// WEBPACK FOOTER //
// src/components/v3/lists/ListBase.vue